import { toast } from "react-toastify";
import { axiosHttpClien } from "../../utils/service";

export const aemInvalidateCache = () => {
    const apiInfo = {
        url: `${process.env.REACT_APP_API_BASE_URL}/abbvie-pro/aem/invalidate-cache`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    };
    axiosHttpClien(apiInfo)
        .then((result) => {
            if (result?.data?.message) {
                toast.success("Invalidate Cache Successfully");
            } else {
                toast.error("Invalid Request");
            }
        })
        .catch((err) => {
            toast.error(err.message || "Invalid Request");
        });
};
